import { useMemo } from 'react';
import { useCurrentUser } from '~/queries';
import { getUserNameFromDetails } from '../utils/getUserNameFromDetails';

export const useUser = () => {
  const { data: currentUser } = useCurrentUser();
  return currentUser as Exclude<typeof currentUser, undefined>;
};

export const useUserName = () => {
  const currentUser = useUser();

  return useMemo(() => {
    const displayName = getUserNameFromDetails(currentUser.details);

    if (displayName.length > 30) {
      return `${displayName.substring(0, 30)}...`;
    }

    return displayName;
  }, [currentUser]);
};
